import { LandingButton } from 'components/button/button.styled'
import { LoadingContainer } from 'components/loadingContainer'
import { useImageById } from 'hooks/user/useImage'
import { useIsMobile } from 'hooks/user/useIsMobile'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { EventDetails } from 'types/Event'
import { formatDateYear, formatTime } from 'utils/event'

import {
    Container,
    DateDisplay,
    Description,
    DetailsContainer,
    ImageComponent,
    ImageContainer,
    LocationBox,
    Title,
    WrapperColumn,
} from './eventItem.stlye'

interface EventItemProps {
    event: EventDetails
}

export const EventItem = ({ event }: EventItemProps) => {
    const imageSource = useMemo(() => {
        return event?.custom_image ?? event?.show?.cover_image
    }, [event])

    const { data: imageData, isLoading: isImageLoading, error: imageError } = useImageById(imageSource)

    const navigate = useNavigate()
    const isMobile = useIsMobile()

    const [fontSize, setFontSize] = useState(24)

    const handleRedirect = useCallback(() => {
        navigate(`/musor/${event.show_id}`)
    }, [event.show_id, navigate])

    const formattedDate = `${formatDateYear(new Date(event.event_date))} ${formatTime(new Date(event.event_date))}`

    useEffect(() => {
        const titleLength = event.show.name.length
        if (titleLength < 15) {
            setFontSize(48)
        } else if (titleLength < 25) {
            setFontSize(42)
        } else if (titleLength < 35) {
            setFontSize(36)
        } else {
            setFontSize(32)
        }
    }, [event.show.name])

    return (
        <LoadingContainer isLoading={isImageLoading} error={imageError}>
            <Container>
                <ImageContainer>
                    <ImageComponent alt="show_image" src={imageData?.image_url} onClick={handleRedirect} />
                </ImageContainer>
                <WrapperColumn>
                    <DetailsContainer>
                        <Title fontSize={fontSize}>{event.show.name}</Title>
                        {isMobile && (
                            <>
                                <LocationBox style={{ backgroundColor: event.location?.color || '#ba9d31' }}>
                                    {event.location?.name || 'Helyszín hamarosan...'}
                                </LocationBox>
                                <DateDisplay>{formattedDate}</DateDisplay>
                            </>
                        )}
                        {!isMobile && (
                            <>
                                <DateDisplay>{formattedDate}</DateDisplay>
                                <LocationBox style={{ backgroundColor: event.location?.color || '#ba9d31' }}>
                                    {event.location?.name || 'Helyszín hamarosan...'}
                                </LocationBox>
                            </>
                        )}
                        <Description>{`${event.description}\n${event.show.description}`}</Description>
                        <LandingButton
                            icon="pi pi-arrow-right"
                            iconPos="right"
                            label="Részletek"
                            onClick={handleRedirect}
                            style={{ marginRight: '0' }}
                        ></LandingButton>
                    </DetailsContainer>
                </WrapperColumn>
            </Container>
        </LoadingContainer>
    )
}
